import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'material-ui';
import ExitBtnIcon from '../../icons/ExitBtnIcon';

const Exit = ({ label, exit, color, fullWidth, mobile }) => (
  <Button
    fullWidth={fullWidth}
    style={{ color: color }}
    className={mobile ? 'mobile-exit' : 'desktop-exit'}
  >
    {/* <a href={exit}>{label || ''}</a> */}
    <a href={exit}>
      {mobile ? (
        <ExitBtnIcon className='mobile-exit' color='#fff' />
      ) : (
        <ExitBtnIcon className='desktop-exit' color='#454545' />
      )}
    </a>
  </Button>
);

Exit.propTypes = {
  label: PropTypes.string,
  fullWidth: PropTypes.bool,
  mobile: PropTypes.bool,
  color: PropTypes.string,
  exit: PropTypes.string,
};

export default Exit;



// WEBPACK FOOTER //
// ./src/components/navigation/Exit.js